<template>
  <v-dialog v-model="show" width="700" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">Edit</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
            <v-text-field
              label="Code"
              :class="classPadding"
              v-model="mt.code"
              disabled
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
            <v-text-field
              label="Description"
              :class="classPadding"
              v-model="mt.description"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-checkbox
              label="Payroll"
              :class="classPadding"
              v-model="mt.payrollBit"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-checkbox
              label="TKS"
              :class="classPadding"
              v-model="mt.tksBit"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-checkbox
              label="HRIS"
              :class="classPadding"
              v-model="mt.hrisBit"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-checkbox
              label="Active/Inactive"
              :class="classPadding"
              v-model="mt.activeBit"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-checkbox
              label="Enable Validation of Consecutive PME"
              :class="classPadding"
              v-model="mt.isValidateConsecutivePME"
            ></v-checkbox>
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn color="success" :loading="isSaving" :class="classPadding" @click.stop="save">Save</v-btn>
          </v-col>
        </v-row>-->
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="error" @click.stop="show = false">Close</v-btn>
        <v-btn text color="success" @click.stop="save" :loading="isSaving" v-if="userAccess.update >= 1"
          >Update</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
import isEmpty from "lodash/isEmpty";
import userAccessMixin from "../../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/movementType";
export default {
  mixins: [userAccessMixin],
  data: () => ({
    show: true,
    mt: {},
    isSaving: false,
    classPadding: "my-0 py-0"
  }),
  methods: {
    save() {
      this.isSaving = true;

      this.$axios
        .put(`${API_ENDPOINT}`, this.mt)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.$router.push("/movement-type");
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    }
  },
  computed: {
    ...mapState("movementType", {
      selected: state => state.selected
    })
  },
  created() {
    this.mt = this.selected;

    this.getUserAccessRights("MovType");
  },
  watch: {
    show(val) {
      if (!val) {
        this.$router.push("/movement-type");
      }
    },
    selected(val) {
      if (!isEmpty(val)) {
        this.mt = val;
      }
    }
  }
};
</script>
